import { useMutation } from '@tanstack/react-query';

import { parseApiError, overrideOrganizationHeader } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.enterprises.batchUpdateUserGroups;

type RequestPayload = Parameters<
  typeof apiFn
>[0]['batchUpdateEnterpriseGroupsRequest'];

export const useBatchUpdateEnterpriseGroupsMutation = (
  enterpriseId: string
) => {
  return useMutation({
    mutationFn: (payload: RequestPayload) =>
      apiFn(
        {
          enterpriseId,
          batchUpdateEnterpriseGroupsRequest: payload,
        },
        {
          headers: overrideOrganizationHeader(enterpriseId),
        }
      ),
    onError: (error: unknown) => {
      notify.error(parseApiError(error));
    },
  });
};
